


const firstStepValue = {
    email_id: '',
  };
  
 export default firstStepValue;